import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { setCartItem } from "../../../redux/features/cartSlice";

const BtnMiniAddToCart = ({ ...product }) => {
  const dispatch = useDispatch();
  const moq = product?.multipleOrderQuantity || 1;
  const [quantity, setQuantity] = useState(moq);

  /**
   * 减少商品数量
   */
  const handleDecreaseQty = () => {
    if (quantity <= moq) return;
    setQuantity((prevQuantity) => prevQuantity - moq);
  };

  /**
   * 增加商品数量
   */
  const handleIncreaseQty = () => {
    if (quantity + moq > product?.stock) return;
    setQuantity((prevQuantity) => prevQuantity + moq);
  };

  /**
   * 处理键盘输入数量
   * @param {Event} e - 输入事件
   */
  const handleQuantityChange = (e) => {
    let value = parseInt(e.target.value);
    const stock = parseInt(product?.stock);

    if (isNaN(value) || value < moq) {
      setQuantity(moq);
    } else {
      // 向上取整到最近的倍数
      value = Math.ceil(value / moq) * moq;

      if (value > stock) {
        // 如果倍数超过库存，向下取整到最近的倍数
        value = Math.floor(stock / moq) * moq;
        if (value < moq && stock >= moq) value = moq;
        toast.error(`Only ${stock} items in stock. Adjusted to ${value}.`);
      }
      setQuantity(value);
    }
  };

  /**
   * 将商品添加到购物车
   */
  const setItemToCart = () => {
    const cartItem = {
      product: product?._id,
      name: product?.name,
      price: product?.price,
      image: product?.image[0],
      stock: product?.stock,
      multipleOrderQuantity: moq,
      quantity,
    };

    dispatch(setCartItem(cartItem));
    toast.success("Item added to cart");
  };

  return (
    <div className="text-center sticky-column w-full p-1 md:p-3">
      <div className="wrapper flex flex-col items-center">
        <div className="flex flex-col justify-center items-center w-full max-w-[80px] md:max-w-[114px]">
          <span className="font-bold text-[10px] md:text-sm whitespace-nowrap">
            Min Qty: <span className="font-normal text-[10px] md:text-sm">{moq}</span>
          </span>
          <div className="flex items-center justify-center my-1">
            <button
              type="button"
              className="bg-[#2684fe] text-white hover:bg-blue-600 font-bold py-1 px-2 md:px-3 rounded-l focus:outline-none text-[10px] md:text-sm"
              onClick={handleDecreaseQty}
            >
              -
            </button>
            <input
              type="number"
              step={moq}
              value={quantity}
              onChange={handleQuantityChange}
              className="w-8 md:w-12 text-center border-y border-gray-300 h-[24px] md:h-[34px] focus:outline-none focus:ring-1 focus:ring-blue-500 text-[10px] md:text-sm"
              min={moq}
            />
            <button
              type="button"
              className="bg-[#2684fe] text-white hover:bg-blue-600 font-bold py-1 px-2 md:px-3 rounded-r focus:outline-none text-[10px] md:text-sm"
              onClick={handleIncreaseQty}
            >
              +
            </button>
          </div>
        </div>
        <button
          type="button"
          className="w-full bg-[#2684fe] hover:bg-blue-600 text-white font-bold py-1 md:py-2 rounded focus:outline-none disabled:bg-gray-400 disabled:cursor-not-allowed mt-1 shadow-sm text-[10px] md:text-sm flex justify-center items-center"
          onClick={setItemToCart}
          disabled={product?.stock === 0}
        >
          <i className="fas fa-shopping-cart"></i>
        </button>
      </div>
    </div>
  );
};

export default BtnMiniAddToCart;
